import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=354abbf7&scoped=true"
import script from "./ThemeToggle.vue?vue&type=script&lang=ts"
export * from "./ThemeToggle.vue?vue&type=script&lang=ts"
import style0 from "./ThemeToggle.vue?vue&type=style&index=0&id=354abbf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354abbf7",
  null
  
)

export default component.exports